export const RAPPORT_LISTE_SUCCES = "RAPPORT_LISTE_SUCCES";
export const RAPPORT_LISTE_ECHEC = "RAPPORT_LISTE_ECHEC";
export const RAPPORT_LISTE_REQUETTE = "RAPPORT_LISTE_REQUETTE";
export const RAPPORT_LISTE_RESET = "RAPPORT_LISTE_RESET";

export const RAPPORT_CREER_SUCCES = "RAPPORT_CREER_SUCCES";
export const RAPPORT_CREER_ECHEC = "RAPPORT_CREER_ECHEC";
export const RAPPORT_CREER_REQUETTE = "RAPPORT_CREER_REQUETTE";
